import { ChapterGroup } from './ChapterGroup'
import { withChapterGroup } from './withChapterGroup'

const ConnectedChapterGroup = withChapterGroup(ChapterGroup)

export { ConnectedChapterGroup as ChapterGroup }
